export const isVerified = (user) => !!user?.email_verified && user?.kyc_status === "approved";
